export enum ObjectStateEnum {
  Added = 0,
  Modified = 1,
  Deleted = 2,
  Hidden = 3,
  Unchanged = 4,
}

export class DtoBase {
  public ObjectState: ObjectStateEnum = ObjectStateEnum.Unchanged;
}
